import styled from "styled-components";

export const Summary = styled.div`
  min-width: 732px;
`;

export const Block = styled.div`
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  min-width: 732px;
`;

export const BlockContentContainer = styled.div`
  border: 1px solid rgba(155, 155, 194, 0.3);
  border-radius: 2px;
  width: 700px;
`;

export const BlockHeader = styled.div`
  padding: 12px;
  padding-bottom: 0px;
  box-sizing: border-box;
  background-color: #ffffff;
  width: 700px;
`;

export const Label = styled.div`
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.46px;
  background-color: #f5f5fb;
  border-radius: 2px;
  padding: 12px 16px;
`;

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  padding-bottom: 32px;
  width: 700px;
  background-color: #ffffff;
`;

export const StatusInfo = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;
  margin-left: 30px;
  margin-bottom: 15px;

  svg {
    width: 40px;
    height: 32px;
    margin-right: 44px;
  }
`;

export const StatusLabel = styled.div`
  font-size: 36px;
  letter-spacing: -0.23px;
  font-family: Helvetica-bold;
`;

export const StatusDescription = styled.div`
  margin-left: 115px;
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.39px;
`;

export const CriteriaContentContainer = styled(BlockContentContainer)`
  background-color: #ffffff;
  display: flex;
  padding: 40px;
  min-width: 702px;
  box-sizing: border-box;
`;

export const CriteriaSidePanel = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 32px;

  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.39px;
  line-height: 16.5px;

  > div {
    width: 120px;
    margin-bottom: 16px;
  }
`;

export const CriteriaContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Criteria = styled.div`
  display: flex;
  align-items: center;
  color: #2a2a3d;
  font-size: 12px;
  font-weight: 500;
  width: 140px;
  height: 19px;
  margin-right: 16px;
  svg {
    margin-right: 12px;
  }
  span {
    width: 140px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &:nth-child(3) {
    margin-right: 0px;
  }
`;
